import { useCallback, useEffect, useState } from "react";

import api from "services/api";
import getResourceTemplates from "services/get-resource-templates";

import serveRequestErrors from "common/serve-request-errors";
import serveRequestSuccess from "common/serve-request-success";

import CONSTANTS from "constants/constant";

import ActionEnum from "enum/action";

import ErrorResponseDto from "dto/services/error-response-dto";
import { ContentTypeObj } from "dto/services/resources/resources-template-info-response-dto";

import AppHeading from "components/app-heading";
import AppSelectInput from "components/app-select-input";
import AppResource from "components/pages/page-resources/app-resource";

const PageResources = () => {
	const [activeTemplate, setActiveTemplate] = useState<string>("");
	const [listOfPages, setListOfPages] = useState<ContentTypeObj[]>([]);
	const [templateId, setTemplateId] = useState("");
	const [isLoading, setIsLoading] = useState(false);

	const onHandleGetActiveTemplate = useCallback(async () => {
		setIsLoading(true);

		try {
			const response = await api.get.resources.activeTemplate();

			if (response) setActiveTemplate(response.data?.data || "");
		} catch (error) {
			const err = error as Error | ErrorResponseDto;

			serveRequestErrors(err);

			setIsLoading(false);
		}
	}, []);

	const onHandleGetTemplateInfo = useCallback(async () => {
		try {
			const payload = {
				template: activeTemplate,
			};

			const response = await api.get.resources.templateInfo(payload);

			// Get list of key from response
			if (response) {
				const templateId = response.data.data.templateId;
				const templateContent = response.data.data.resourceConfig.contents;

				setListOfPages(templateContent);

				setTemplateId(templateId);

				setIsLoading(false);
			}
		} catch (error) {
			const err = error as Error | ErrorResponseDto;

			serveRequestErrors(err);
		}
	}, [activeTemplate]);

	const onHandleActiveTemplate = useCallback(async (event: React.ChangeEvent<HTMLInputElement>) => {
		const selectedValue = event.target.value;

		try {
			const payload = {
				template: selectedValue,
			};

			const response = await api.put.resources.updateActiveTemplate(payload);

			if (response) {
				serveRequestSuccess(CONSTANTS.MESSAGES.UPDATED, ActionEnum.Update);
				setActiveTemplate(selectedValue);
			}
		} catch (error) {
			const err = error as Error | ErrorResponseDto;

			serveRequestErrors(err);
		}
	}, []);

	useEffect(() => {
		onHandleGetActiveTemplate();
	}, [onHandleGetActiveTemplate]);

	useEffect(() => {
		if (activeTemplate) onHandleGetTemplateInfo();
	}, [activeTemplate, onHandleGetTemplateInfo]);

	return (
		<div className="page-resources">
			<div className="resources">
				<AppHeading title="Resources">
					<AppHeading.Divider />
				</AppHeading>

				<div className="resources__container">
					<div className="resources__header">
						<h3 className="resources__header-title">Active Template:</h3>
						<AppSelectInput
							key="activeTemplateInput"
							name="activeTemplateInput"
							placeholder="Please Select"
							value={activeTemplate}
							onChange={onHandleActiveTemplate}
							loadOptions={getResourceTemplates}
							searchable={true}
						/>
					</div>

					{listOfPages.length > 0 && (
						<div className="resources__content">
							{listOfPages.map((obj) => (
								<AppResource key={obj.page} headerKey={obj.page} headerLabel={obj?.label ?? ""} info={obj.values} activeTemplate={activeTemplate} templateId={templateId} />
							))}
						</div>
					)}

					{!isLoading && listOfPages.length === 0 && <p className="resources__content-text">No Content To Be Shown</p>}
				</div>
			</div>
		</div>
	);
};

export default PageResources;
